import React from 'react';
import Loader from './Loader';

function Loadable(Component) {
  return function LoadableComponent(props) {
    return (
      <React.Suspense fallback={<Loader />}>
        <Component {...props} />
      </React.Suspense>
    );
  };
}

export default Loadable;
